






















import Vue from 'vue';
import { DocumentModel, DocumentPagePreferencesModel, ThumbnailSearchModel, ThumbnailViewModel } from '@/types';
import MStoreThumbnailView from '@/components/shared/MStoreThumbnailView.vue';
import { DocumentConstants } from '@/types/constants';
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/classes/EventBus';

export default Vue.extend({
  name: 'MStoreThumbnailViewList',
  components: {
    MStoreThumbnailView
  },
  data() {
    return {
      resizeThumbnails: false
    };
  },
  props: {
    document: {
      type: Object as () => DocumentModel,
      required: true
    },
    maximumImageHeight: {
      type: Number,
      default: 150
    },
    selectedPage: {
      type: Number,
      required: false
    },
    maximumImagesToPreload: {
      type: Number,
      default: 2
    },
    thumbnailClickEnabled: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('thumbnailStore', ['getThumbnail', 'getAllThumbnails']),
    thumbnails(this: any) {
      const pageRange = Array.from({ length: this.document.totalPages });
      return pageRange.map((pageNum, index) => {
        const thumbnailInStore = this.getAllThumbnails.find((x: ThumbnailViewModel) => x.cabinetId === this.document.cabinetId && x.documentId === this.document.id && x.page === index + 1);
        const pageRotationPreferences = this.document.documentPagePreferences?.find((x: DocumentPagePreferencesModel) => x.page === index + 1);
        const thumbnailClone: ThumbnailViewModel = thumbnailInStore ? { ...thumbnailInStore } : ({ page: index + 1 } as ThumbnailViewModel);
        thumbnailClone.documentPagePreference = pageRotationPreferences ? { ...pageRotationPreferences } : null;
        return thumbnailClone;
      });
    },
    aSeriesPaperAspectRatio() {
      return DocumentConstants.ASeriesPaperAspectRatio;
    },
    containerStyle(this: any): string {
      return `width: calc(${this.maximumImageHeight * this.aSeriesPaperAspectRatio}px + 1.5rem);`;
    },
    getIntersectMargin(this: any) {
      return `0px 0px ${this.maximumImageHeight * this.maximumImagesToPreload}px 0px`;
    },
    getThumbnailForPage(this: any) {
      return (pageNumber: number): void => {
        const searchModel = {
          documentId: this.document.id,
          cabinetId: this.document.cabinetId,
          page: pageNumber,
          maximumHeightInPixels: Math.floor(this.maximumImageHeight),
          maximumWidthInPixels: Math.floor(this.maximumImageHeight * this.aSeriesPaperAspectRatio)
        } as ThumbnailSearchModel;
        const thumbnail = this.getThumbnail(searchModel) as ThumbnailViewModel;
        if (!thumbnail) {
          this.setThumbnail(searchModel);
        }
      };
    },
    selectedThumbnailClass(this: any) {
      return (thumbnail: ThumbnailViewModel) => {
        const thumbnailClass = this.selectedPage === thumbnail?.page ? 'bg-info' : '';
        return this.thumbnailClickEnabled ? thumbnailClass : `${thumbnailClass} cursor-default`;
      };
    }
  },
  methods: {
    ...mapActions('thumbnailStore', ['setThumbnail']),
    onPageClick(thumbnail: ThumbnailViewModel) {
      if (thumbnail && this.thumbnailClickEnabled) {
        this.$emit('pageClick', thumbnail.page);
      }
    },
    getThumbnailKey(index: number): string {
      return `${this.document.id}_${index}`;
    },
    resizeThumbnailContainers() {
      this.resizeThumbnails = !this.resizeThumbnails;
    }
  },
  watch: {
    selectedPage: {
      handler() {
        this.$nextTick(() => {
          const element = document.querySelector('.bg-info');
          element?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    }
  },
  mounted() {
    EventBus.$on('thumbnailRotationChange', (documentPagePrefernceModel: DocumentPagePreferencesModel) => {
      const thumbnailToUpdate = this.thumbnails.find((x: any) => x.page === documentPagePrefernceModel.page);
      if (!thumbnailToUpdate) {
        return;
      }
      if (thumbnailToUpdate?.documentPagePreference) {
        thumbnailToUpdate.documentPagePreference.rotation = documentPagePrefernceModel.rotation;
      } else {
        thumbnailToUpdate.documentPagePreference = documentPagePrefernceModel;
      }
      this.$nextTick(() => {
        this.resizeThumbnailContainers();
      });
    });
  },
  beforeDestroy(this: any) {
    EventBus.$off('thumbnailRotationChange');
  }
});
